function Accordion({ item, active, onFAQClick, index }) {
  return (
    <div className="accordion padding_top15">
      <div className="toggle ttm-toggle_style_classic ttm-control-right-true ttm-toggle-title-bgcolor-grey">
        <div className="toggle-title">
          <a
            className={`${
              item.id === active || index === active ? "active" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => onFAQClick(item.id)}
          >
            {item.question}
          </a>
        </div>
        <div
          className="toggle-content p-20"
          style={{
            display: item.id === active || index === active ? "block" : "none",
          }}
        >
          <p>{item.answer}</p>
        </div>
      </div>
    </div>
  );
}

export default Accordion;
